class gatherboxController {
    constructor($http,$timeout,$interval,$filter,message,$scope,localStorageService,FileUploader,ArticleAPI,AppConfig,modal,mediaAccount,gatherTip) {
        "ngInject";
        let self=this;
        this.$http = $http;
        this.$timeout=$timeout;
        this.$interval=$interval;
        this.message=message;
        this.$scope=$scope;
        this.localStorageService=localStorageService;
        this.AppConfig=AppConfig;
        this.ArticleAPI=ArticleAPI;
        this.mediaAccount=mediaAccount;
        this.modal=modal;
        this.FileUploader=FileUploader;
        this.gatherTip=gatherTip;
        this.check_timer=null;
        this.tranlsteFilter=$filter('translate');

        this.imageUploadPolicy = null;
        this.uploading=false;
        this.publishing=false;

        this.getImageUploadPolicy();

        mediaAccount.init();

        //this.$scope.gatherArticle=[{"article_id":41264,"title":"国家发改委部署加强2017年国庆中秋期间市场价格监管","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/12/1505301363258_842.png"},{"article_id":41278,"title":"上海市旅游局携手光明乳业 打造首届上海酸奶节","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/040df697a27ae3003853180cd40eae1e.jpeg"},{"article_id":41275,"title":"四川省企业经济促进会赴邛崃开展成都区域雾霾形成主要原因及治理现状调研","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/98bd3883db3af0946ff70ba89c03b41c.jpeg"},{"article_id":41274,"title":"宝马加速新产品攻势 率大型豪华车亮相法兰克福车展","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/380abcc8abf2b7f0a0238d7c176f4481.jpeg"},{"article_id":41270,"title":"信阳“互联网+精准扶贫”新思路 贫困村生态农产品进社区","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/c600229d370876ab6136a25083d92b28.jpeg"},{"article_id":41268,"title":"河南信阳：“特岗计划”助力城乡教育均衡发展","image_url":"https://yb-img-staging.oss-cn-shanghai.aliyuncs.com/system/gather-bg.jpg"},{"article_id":41267,"title":"“老家河南·山水太行”旅游推介会走进北京","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/960ed24c66756a7989fb0d8f52685aea.jpeg"},{"article_id":41263,"title":"北京发改委王英建：力保双创活动周北京主题展参展项目全新","image_url":"https://yb-img-staging.oss-cn-shanghai.aliyuncs.com/system/gather-bg.jpg"}]

        this.$scope.$watch('gatherArticle',  (newValue) => {
            if (newValue) {
                this.localStorageService.set('gatherArticle_'+this.appUser.id,newValue);

                this.gatherInit(newValue);
            }
        }, true);
        this.$scope.gatherArticle=this.retrieve();
    }

    store() {
        //存文章
        let self=this;
        self.$scope.gatherArticle.length=0;
        angular.copy(self.retrieve(),self.$scope.gatherArticle);
        let articles=this.$scope.gatherArticle=this.retrieve();
        if(articles.length>=8){
            this.message.error(self.tranlsteFilter('page-original-text050'));
            return false;
        }
        let isExist=articles.some((item)=>{
            return item.article_id==this.article.id
        });
        if(!isExist){
            articles.push({
                article_id:this.article.id,
                title:this.article.title,
                image_url:this.article.main_article_image || this.AppConfig.aliyun_url+'/system/gather-bg.jpg'
            });

        }else{
            this.message.warn(self.tranlsteFilter('page-original-text051'));
        }
    }
    remove(idx){
        //删文章
        let articles=this.$scope.gatherArticle;
        articles.splice(idx,1);

        // let idx = -1;
        // articles.forEach((item,index)=>{
        //     if(item.article_id==id){
        //         idx=index;
        //         return;
        //     }
        // });
        //
        // if(idx!=-1){
        //     articles.splice(idx,1)
        // }
    }
    retrieve() {
        //取文章
        return this.localStorageService.get('gatherArticle_'+this.appUser.id) || [];
    }
    //清空本地储存
    clearGatherArticle() {
        this.$scope.gatherArticle.length=0;
    }
    //移动
    changePos(idx,pos){
        let articles=this.$scope.gatherArticle;
        let toIndex=idx+pos;
        if(pos==-1 && toIndex<=-1){
            toIndex=articles.length-1;
        }
        if(pos==1 && toIndex==articles.length){
            toIndex=0;
        }
        articles[toIndex]=articles.splice(idx,1,articles[toIndex])[0];
    }
    //获取用户上传图片权限
    getImageUploadPolicy() {
        let self = this;
        this.ArticleAPI.one('image').one('policy').get().then(
            (policy) => {
                self.imageUploadPolicy = policy;
            },
            (response) => {
                self.message.error(response.data);
            }
        );
    }
    //获取文件后缀名
    getSuffix(filename) {
        let pos = filename.lastIndexOf('.');
        if (pos != -1) {
            return filename.substring(pos)
        }
        return '';
    }

    //一键发布
    publish(){
        let self = this;
        if(!self.mediaAccount.mediaAccounts['weixin']){
            self.gatherTip.info(self.tranlsteFilter('page-original-text052')+'，<a href="'+location.origin+'/home/profile/media" target="_blank">'+self.tranlsteFilter('page-original-text054')+' </a>');
            return
        }
        if(self.mediaAccount.mediaAccounts['weixin'] && !self.mediaAccount.mediaAccounts['weixin']['access_token']){
            self.gatherTip.info(self.tranlsteFilter('page-original-text053')+'，<a href="'+location.origin+'/home/profile/media" target="_blank">'+self.tranlsteFilter('page-original-text055')+'</a>');
            return
        }

        self.publishing = true;
        self.gatherTip.info(self.tranlsteFilter('page-original-text056'));

        this.$http.post(this.AppConfig.server_url + '/weixin/articles/combinations', this.$scope.gatherArticle, {
            withCredentials: true
        }).then(
            (res) => {

                if(res.data.status.code==200){
                    self.check_timer=self.$interval(()=>{
                        self.checkStatus.bind(self);
                        self.checkStatus();
                    },1500)
                }else if(res.data.status.code==422){
                    self.publishing = false;
                    self.gatherTip.error(res.data.status.message);
                }
            },
            (response) => {
                self.publishing = false;
                self.gatherTip.error(self.tranlsteFilter('page-original-text057'));
            }
        );

    }
    checkStatus(){
        let self=this;
        self.$http.get(this.AppConfig.server_url + '/weixin/articles/combinations/status', {
            withCredentials: true
        }).then(
            (res) => {
                if(res.data.data.process=='ok'){
                    self.publishing = false;
                    self.$interval.cancel(self.check_timer);
                    let img='';
                    if(self.mediaAccount.mediaAccounts['weixin']['params']['head_img']){
                        img='<img style="width: 26px;height: 26px;border-radius: 100%;vertical-align: middle;margin: 0 5px;"' +
                            'src="'+self.mediaAccount.mediaAccounts['weixin']['params']['head_img']+'"  alt="" class="social-face">';
                    }
                    if($('#gather-modal').hasClass('active')){
                        self.gatherTip.success(self.tranlsteFilter('page-original-text058') +self.mediaAccount.mediaAccounts['weixin']['name']);
                    }else{
                        self.gatherTip.success(self.tranlsteFilter('page-original-text058')+self.mediaAccount.mediaAccounts['weixin']['name']);
                        self.message.success(self.tranlsteFilter('page-original-text058')+self.mediaAccount.mediaAccounts['weixin']['name']);
                    }
                    localStorage.setItem("publishingStatus", JSON.stringify({status : 'ok', now : Date.now()}));
                }
            },
            (response) => {
                self.publishing = false;
                self.gatherTip.error(response.data);
            }
        );
    }
    showModal(){
        let self=this;
        self.$scope.gatherArticle.length=0;
        angular.copy(self.retrieve(),self.$scope.gatherArticle);
        //this.gatherInit(self.$scope.gatherArticle);
        this.modal.open('gather-modal')
    }
    gatherInit(newValue){
        let self=this;
        newValue.length && newValue.forEach((article,index,arr)=>{
            let currentImageFilename = '';
            this['uploader_'+article.article_id] = new self.FileUploader({
                autoUpload: true,
                removeAfterUpload: true,
                onSuccessItem: function (item, response, status, headers) {
                    self.$scope.gatherArticle.forEach((item)=>{
                        if(item.article_id==article.article_id){
                            item.image_url = self.imageUploadPolicy['host'] + '/' + currentImageFilename;
                            return;
                        }
                    });
                    //self.$scope.$digest();

                    self.uploading=false;
                    self.gatherTip.hide();
                },
                onBeforeUploadItem: function (item) {
                    let size = item.file.size;
                    self.coverError = null;
                    if (size >= 2 * 1024 * 1024) {
                        self['uploader_'+article.article_id].cancelItem(item);
                        self.gatherTip.error(self.tranlsteFilter('page-original-text059'));

                        return;
                    }
                    let type = item.file.type;
                    if (["image/png", "image/jpeg", "image/bmp"].indexOf(type) == -1) {
                        self['uploader_'+article.article_id].cancelItem(item);
                        self.gatherTip.error(self.tranlsteFilter('page-original-text060'))
                        return;
                    }
                    self.uploading=true;
                    self.gatherTip.info(self.tranlsteFilter('page-original-text061'))
                    let fileSuffix = self.getSuffix(item.file.name);
                    let filename = Date.now() + '_' + Math.floor(Math.random() * 1000);

                    currentImageFilename = self.imageUploadPolicy['key'] + filename + fileSuffix;
                    item.url = self.imageUploadPolicy['host'];
                    item.formData = [
                        {
                            'key': currentImageFilename
                        },
                        {
                            'policy': self.imageUploadPolicy['policy']
                        },
                        {
                            'OSSAccessKeyId': self.imageUploadPolicy['accessid']
                        },
                        {
                            'success_action_status': '200'
                        },
                        {
                            'callback': ''
                        },
                        {
                            'signature': self.imageUploadPolicy['signature']
                        }
                    ];
                }
            });
        });

    }

    $onInit(){
        let self=this;
        $(window).on('storage', function(ev) {
            var event = ev.originalEvent,
                message = event.newValue && JSON.parse(event.newValue);// 解析出复合的对象值
            // 对获取到的值进行处理

            if(message && message.status=='ok'){
                self.message.success(self.tranlsteFilter('page-original-text058')+self.mediaAccount.mediaAccounts['weixin']['name']);
            }
        })

    }
}

export default gatherboxController;



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-article/gather-box/gather-box.controller.js